import * as React from "react"
import {whiteLink,whiteLinkBlueHover} from './shared.module.scss'
import DropdownSearchNav from './tiny_components/dropdownSearchNav'
import { Link } from "gatsby"

const CorporateMenuLinks = ({menuClicked})=>{

    return(
          <div className="navbar-end">
              <DropdownSearchNav menuClicked={menuClicked} useHoverState={true}/>

              <Link to="/residentportals/" className={`${whiteLink} navbar-item ${whiteLinkBlueHover} topnav-residents`} id="residents_link">
                  Residents
              </Link>
              <Link to="/vendors/" className={`${whiteLink} navbar-item ${whiteLinkBlueHover} topnav-vendors`} id="career_link">
                Vendors
              </Link>
              <Link to="/career/" className={`${whiteLink} navbar-item ${whiteLinkBlueHover} topnav-careers`} id="career_link">
                  Careers
              </Link>
              <Link to="/about/" className={`${whiteLink} navbar-item ${whiteLinkBlueHover} topnav-about`} id="about_link">
                  About
              </Link>
          </div>
    )
}


export default CorporateMenuLinks
